import { useQueryClient } from '@tanstack/react-query';
import { useParams, useNavigate } from 'react-router-dom';
import { Param, paramsConstants } from '../../data/types/params.types';
import { useEffect, useState } from 'react';
import { api } from '../../data/api';
import toast from 'react-hot-toast';
import { Spinner } from '../../components/spinner/Spinner.component';
import { SmartForm } from '../../components/formFields/Form';
import { TextField } from '../../components/formFields/TextField';

interface Entity extends Param {}
const entityConstants = paramsConstants

export const ParamsForm = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const [formData, setFormData] = useState<Partial<Entity>>({
		id: '',
		value: '',
	});

	const [loading, setLoading] = useState(!!id);
	const [errors, setErrors] = useState<Record<string, string>>({});

	useEffect(() => {
		if (id) {
			const loadData = async () => {
				try {
					setLoading(true);
					const {data} = await api.get<Entity[]>(`${entityConstants.apiEndpoint}/${id}`);
					const response: Entity = data[0];
					setFormData(response);
				} catch (err) {
					console.error("### error", err);
					toast.error(`Error cargando ${entityConstants.entityLabelGender === 'M' ? 'el' : 'la'} ${entityConstants.entityLabel.toLowerCase()}`);
				} finally {
					setLoading(false);
				}
			}
			loadData();
		}
	}, [id]);

	const validateForm = () => {
		// TODO: validar según tipo de parametro?
		return true;
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!validateForm()) return;

		try {
			await api.post(`${entityConstants.apiEndpoint}/`, formData);
			toast.success(`${entityConstants.entityLabel} ${entityConstants.entityLabelGender === 'M' ? ' guardado' : ' guardada'}`);
			queryClient.invalidateQueries({queryKey: ['params']});
			navigate(entityConstants.navigateToParent);
		} catch (err) {
			console.error("### error", err);
			toast.error(`Error guardando ${entityConstants.entityLabel}`);
		}
	}

	if (loading) return <Spinner />

	return (
		<SmartForm
			title={id ? `Editar ${entityConstants.entityLabel}` : `Nuevo ${entityConstants.entityLabel}`}
			onSubmit={handleSubmit}
			cancelButtonNavigateTo={entityConstants.navigateToParent}
			confirmButtonLabel={id ? 'Actualizar' : 'Crear'}
		>
			<TextField
				label="Parámetro"
				value={formData.id || ''}
				// onChange={(value) => setFormData({ ...formData, id: value })}
				disabled={true}
			/>
			<TextField
				label="Valor"
				value={formData.value || ''}
				onChange={(value) => setFormData({ ...formData, value: value })}
				error={errors.value}
				placeholder=""
			/>
		</SmartForm>
	)
}
